import './BottomBar.less';

export const prefix = 'bm-c-bottom-bar';

export { default } from './BottomBar';

export { default as ShareType } from './ShareType';
